import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from "../shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TrackApplicationRoutingModule } from './track-application-routing.module';

import { ApplicationTrackingComponent } from './application-tracking/application-tracking.component';
import { TrackappErrorComponent } from './trackapp-error/trackapp-error.component';
import { CorporateCardComponent } from './corporate-card/corporate-card.component';

@NgModule({
  declarations: [ApplicationTrackingComponent, TrackappErrorComponent, CorporateCardComponent],
  imports: [
    CommonModule,
    // TrackApplicationRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,

  ],
  exports: [ApplicationTrackingComponent, TrackappErrorComponent, CorporateCardComponent]
})
export class TrackApplicationModule { }
